const tabs = [
  {
    label: 'Client Profile',
    name: 'client_profile',
    path: '',
  },
  {
    label: 'Default Retirement Plan',
    name: 'default_retirement_plan',
    path: '/default_plan',
  },
  {
    label: 'Redesigned Income Plan',
    name: 'redesigned_income_plan',
    path: '/income_plan',
  },
  {
    label: 'Income by Year',
    name: 'income_by_year',
    path: '/income_year',
  },
  {
    label: 'Assets by Year',
    name: 'assets_by_year',
    path: '/assets_year',
  },
  {
    label: 'Reports',
    name: 'reports',
    path: '/reports',
  },
]

export default tabs;